export default class ShopPress extends HTMLElement {
    private embla: any = null
    private viewportEl: HTMLElement
    private prevButtonEl: HTMLElement | null = null
    private nextButtonEl: HTMLElement | null = null

    constructor() {
        super()
        this.viewportEl = this.querySelector('.embla__viewport') as HTMLElement
        this.prevButtonEl = this.querySelector('[data-button-prev]')
        this.nextButtonEl = this.querySelector('[data-button-next]')

        this.prevButtonEl?.addEventListener('click', this.handlePrevClick.bind(this))
        this.nextButtonEl?.addEventListener('click', this.handleNextClick.bind(this))
    }

    connectedCallback() {
        if (this.viewportEl) {
            import('embla-carousel').then((EmblaCarousel) => {
                this.embla = EmblaCarousel.default(this.viewportEl, {
                    loop: true,
                    align: 'start',
                })
            })
        }
    }

    disconnectedCallback() {
        if (this.embla) {
            this.embla.destroy()
        }
    }

    handlePrevClick() {
        this.embla?.scrollPrev()
    }

    handleNextClick() {
        this.embla?.scrollNext()
    }
}

customElements.define('shop-press', ShopPress)
